import Swiper, { Navigation, Autoplay } from "swiper";

const AnnouncementBar = class extends HTMLElement {
  slider: HTMLElement | null;

  constructor() {
    super();
    this.slider = this.querySelector(".announcement-bar__messages");

    if (!this.slider) return;

    const wrapper = document.createElement("div");
    const nextBtn = document.createElement("button");
    const prevBtn = document.createElement("button");
    const slides = this.querySelectorAll(".announcement-bar__message");

    if (slides.length <= 1) return;

    this.slider.classList.add("swiper");
    wrapper.classList.add("swiper-wrapper");

    nextBtn.classList.add("next-btn", "button", "button--carousel", "button--black", "button--small");
    nextBtn.innerHTML = `<svg><use xlink:href="#icon-chevron-right-small"></use></svg>`;

    prevBtn.classList.add("prev-btn", "button", "button--carousel", "button--black", "button--small");
    prevBtn.innerHTML = `<svg><use xlink:href="#icon-chevron-left-small"></use></svg>`;

    for (const slide of slides) {
      slide.classList.add("swiper-slide");
      wrapper.appendChild(slide);
    }

    this.slider.innerHTML = "";
    this.slider.appendChild(wrapper);
    this.slider.appendChild(prevBtn);
    this.slider.appendChild(nextBtn);

    new Swiper(this.slider, {
      loop: true,
      modules: [Navigation, Autoplay],
      autoplay: {
        delay: 5000,
      },
      direction: "vertical",
      speed: 200,
      navigation: {
        nextEl: ".next-btn",
        prevEl: ".prev-btn",
      },
    });
  }
};

customElements.define("announcement-bar", AnnouncementBar);
